export default __webpack_public_path__ + "static/media/autolike-status@2x.0f2a77d6.png";